import React, { useState } from 'react';
import { Col, Form, Input, Row, Typography, Checkbox, Space } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const DEFAULT_INSTRUCTION = "You are a customer service AI assistant created by Custom Answer, designed to help customers of this platform account.";

const AgentNameInput = () => {
    const { t } = useTranslation();
    const [editInstructions, setEditInstructions] = useState(false);
    
    return (
        <>
            <Col xs={24} md={12}>
                <Form.Item
                    name="name"
                    label={t('agent_name')}
                    style={{ marginBottom: 4 }}
                    rules={[{ required: true, message: t('please_input_the_agent_name') }]}
                >
                    <Input placeholder={t('enter_agent_name')} />
                </Form.Item>
            </Col>
            
            <Col xs={24}>
                <div style={{ marginTop: '16px' }}>
                    <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>Agent Instructions</Text>
                    <Row gutter={[16, 0]} align="middle">
                        <Col xs={24}>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Checkbox 
                                    checked={editInstructions} 
                                    onChange={(e) => setEditInstructions(e.target.checked)}
                                >
                                    Customize Agent Instructions
                                </Checkbox>
                                <Form.Item 
                                    style={{ marginBottom: 0 }}
                                    name="system_instruction"
                                    label="Agent Instructions (please adapt to your context)"
                                    labelCol={{ style: { paddingBottom: 4, display: editInstructions ? 'block' : 'none' } }}
                                >
                                    <Input.TextArea 
                                        rows={4} 
                                        disabled={!editInstructions}
                                    />
                                </Form.Item>
                            </Space>
                        </Col>
                    </Row>
                </div>
            </Col>
        </>
    );
};

export default AgentNameInput;
